import React from "react";
import { useLanguage } from "@/lib/i18n";
import LegalLayout from "@/components/legal/LegalLayout";

export default function PrivacyPolicy() {
  const { t } = useLanguage();
  return (
    <LegalLayout titleKey="legal.privacy.title" testid="legal-privacy-page">
      <Section title={t("legal.privacy.s1.title")}>
        <p>{t("legal.privacy.s1.body")}</p>
      </Section>

      <Section title={t("legal.privacy.s2.title")}>
        <ul className="list-disc pl-5 space-y-1">
          <li>{t("legal.privacy.s2.responsible")}</li>
          <li>{t("legal.privacy.s2.location")}</li>
          <li>{t("legal.privacy.s2.contact")}</li>
        </ul>
      </Section>

      <Section title={t("legal.privacy.s3.title")}>
        <p>{t("legal.privacy.s3.intro")}</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>{t("legal.privacy.s3.item1")}</li>
          <li>{t("legal.privacy.s3.item2")}</li>
          <li>{t("legal.privacy.s3.item3")}</li>
          <li>{t("legal.privacy.s3.item4")}</li>
        </ul>
        <p className="mt-3 text-sm bg-[#F9F8F6] border-l-2 border-[#B4C5A4] pl-3 py-2 text-[#475569]">
          {t("legal.privacy.s3.healthNote")}
        </p>
      </Section>

      <Section title={t("legal.privacy.s4.title")}>
        <ul className="list-disc pl-5 space-y-1">
          <li>{t("legal.privacy.s4.purpose1")}</li>
          <li>{t("legal.privacy.s4.purpose2")}</li>
          <li>{t("legal.privacy.s4.purpose3")}</li>
        </ul>
      </Section>

      <Section title={t("legal.privacy.s5.title")}>
        <p>{t("legal.privacy.s5.body")}</p>
      </Section>

      <Section title={t("legal.privacy.s6.title")}>
        <p>{t("legal.privacy.s6.body")}</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>{t("legal.privacy.s6.provider1")}</li>
          <li>{t("legal.privacy.s6.provider2")}</li>
          <li>{t("legal.privacy.s6.provider3")}</li>
        </ul>
        <p className="mt-3 text-sm text-[#475569]">
          {t("legal.privacy.s6.note")}
        </p>
      </Section>

      <Section title={t("legal.privacy.s7.title")}>
        <p>{t("legal.privacy.s7.body")}</p>
      </Section>

      <Section title={t("legal.privacy.s8.title")}>
        <p>{t("legal.privacy.s8.intro")}</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>{t("legal.privacy.s8.right1")}</li>
          <li>{t("legal.privacy.s8.right2")}</li>
          <li>{t("legal.privacy.s8.right3")}</li>
          <li>{t("legal.privacy.s8.right4")}</li>
          <li>{t("legal.privacy.s8.right5")}</li>
          <li>{t("legal.privacy.s8.right6")}</li>
        </ul>
        <p className="mt-3">{t("legal.privacy.s8.howTo")}</p>
        <p className="mt-3 text-sm text-[#475569]">
          {t("legal.privacy.s8.complaint")}
        </p>
      </Section>

      <Section title={t("legal.privacy.s9.title")}>
        <p>{t("legal.privacy.s9.body")}</p>
      </Section>

      <Section title={t("legal.privacy.s10.title")}>
        <p>{t("legal.privacy.s10.body")}</p>
      </Section>
    </LegalLayout>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-sans-display text-lg text-[#0B2545] tracking-tight mt-8 mb-3">
        {title}
      </h2>
      {children}
    </section>
  );
}
